import { OnboardingTooltipType } from '../../types/onboarding-tooltip.type';

export const historyTutorial: readonly OnboardingTooltipType[] = [
  {
    title: 'premier tooltip',
    content: "des petites infos pour aider l'utilisateur",
    videoYoutubeUrl: 'https://www.youtube.com/embed/mH4NLGI64MM',
    target: '',
  },
  {
    title: "deuxième tooltip de l'histoire",
    content: "des petites infos pour aider l'utilisateur avec plus de texte",
    target: '',
  },
  {
    title: 'un troisième tooltip',
    content: "enfin de nouvelles petites infos pour aider l'utilisateur, il va etre content",
    target: '',
  },
];
